import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../styles/dashboard-styles';
import FormGroup from '@material-ui/core/FormGroup';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import BackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import moment from 'moment';

const InfoPanel = (props) => {
  const { classes } = props;
  return (
     <div className={classes.panelInfo}>
     { !props.detailsMonitorId 
      ?
        <form>
          <FormGroup row>
            <Select
            classes={{root: classes.sortMenuItem}}
            value={props.sortOrder}
            onChange={(e) => {props.handleInputChange(e)}}
            inputProps={{
              name: 'sortOrder',
              id: 'sortOrder',
            }}>
              <MenuItem value={"alpha"}>A to Z</MenuItem>
              <MenuItem value={"alerts"}>New Alerts First</MenuItem>
            </Select>
          </FormGroup>
        </form>
        : <div>
            <IconButton onClick={e => {props.handleSetMonitorId(e, null)}}>
              <BackIcon />
            </IconButton>
            <Typography 
              variant="body2"
              inline
            >
            Back to Monitor Charts
            </Typography>
          </div>  }
        <div>
        <Typography
          component="p"
          variant="body2"
          inline
        >
          {props.lastUpdate 
            ? `Last updated: ${moment(props.lastUpdate).format("DD MMM, YYYY HH:mm")} GMT`
            : null
          }
        </Typography>
        <Button
          onClick={props.refreshMonitors}
          className={classes.refreshButton}
        >
          {props.updateNowText}
        </Button>
      </div>
    </div>
  )
}

InfoPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InfoPanel);



// WEBPACK FOOTER //
// ./src/components/InfoPanel.js